// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__WCMaO","col":"styles_col__1cp8c","fulfillmentStatus":"styles_fulfillmentStatus__3jz4T","emailCol":"styles_emailCol__1Fdk-"};